import { ActionIcon, Box, Group, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconX } from '@tabler/icons-react';

interface DialogBoxProps {
    title: string;
    description?: string;
    withCloseButton?: boolean;
    children: React.ReactNode;
}

export const openDialogBox = ({ title, description, withCloseButton = true, children }: DialogBoxProps) => {
    const modalId = modals.open({
        withCloseButton: false,
        centered: true,
        size: "sm",
        children: (
            <Box>
                <Stack gap={4} mb="xs">
                    <Group justify="space-between">
                        <Text fz="1rem" fw={500}>{title}</Text>
                        {withCloseButton &&
                            <ActionIcon className="unify-action-icon-subtle" w={26} h={26} onClick={() => { modals.close(modalId) }}>
                                <IconX size="1rem" />
                            </ActionIcon>
                        }
                    </Group>
                    <Text fz="0.875rem" c="var(--text-dimmed)">{description}</Text>
                </Stack>
                {children}
            </Box>
        )
    });
};

export const closeAllDialogs = () => {
    modals.closeAll();
};